import VueRouter, { RouteConfig } from 'vue-router'

const Auth = () => import('../views/Auth.vue')
const AuthForm = () => import('../views/authform/Index.vue')
const AdAuthForm = () => import('../views/AdAuthForm.vue')

const QrCodeLogin = () => import('../views/QrCodeLogin.vue')
const AccountLogin = () => import('../views/AccountLogin.vue')
const AuthInProgress = () => import('../views/AuthInProgress.vue')
const AuthSchoolSelect = () => import('../views/AuthSchoolSelect.vue')

export const authRoute: RouteConfig = {
  path: '/auth',
  name: 'auth',
  component: Auth,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '申请教师管理账号',
  },
}

export const authFormRoute: RouteConfig = {
  path: '/auth-form',
  name: 'auth_form',
  component: AuthForm,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '申请教师管理账号',
  },
}

export const adAuthFormRoute: RouteConfig = {
  path: '/ad-auth-form',
  name: 'ad_auth_form',
  component: AdAuthForm,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const qrCodeLoginRoute: RouteConfig = {
  path: '/account/login-qrcode',
  name: 'account_login_qrcode',
  component: QrCodeLogin,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const accountLoginRoute: RouteConfig = {
  path: '/account/login',
  name: 'account_login',
  component: AccountLogin,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const authInprogressRoute: RouteConfig = {
  path: '/auth-in-progress',
  name: 'auth_in_progress',
  component: AuthInProgress,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '申请教师管理账号',
  },
}

export const authSchoolSelectRoute: RouteConfig = {
  path: '/auth-school-select',
  name: 'auth_form_school_select',
  component: AuthSchoolSelect,
  props: (route) => ({
    ...route.query,
    ...route.params,
    isCollege: route.query.isCollege && JSON.parse(route.query.isCollege as any),
  }),
}

export default [
  authRoute,
  authFormRoute,
  adAuthFormRoute,
  qrCodeLoginRoute,
  accountLoginRoute,
  authInprogressRoute,
  authSchoolSelectRoute,
]

export function navigateToAuth(router: VueRouter) {
  router.push({ name: authRoute.name })
}

export function redirectToAuth(router: VueRouter) {
  router.replace({ name: authRoute.name })
}

export function navigateToAuthForm(router: VueRouter, invitationCode = '', channel = '', type = 'junior') {
  router.push({ name: authFormRoute.name, query: { invitationCode, channel, type } })
}

export function redirectToAuthFrom(router: VueRouter, invitationCode = '', channel = '') {
  router.replace({ name: authFormRoute.name, query: { invitationCode, channel } })
}

export function navigateToAdAuthForm(router: VueRouter, invitationCode = '', channel = '') {
  router.push({ name: adAuthFormRoute.name, query: { invitationCode, channel } })
}

export function redirectToAdAuthFrom(router: VueRouter, invitationCode = '', channel = '') {
  router.replace({ name: adAuthFormRoute.name, query: { invitationCode, channel } })
}

export function navigateToAccountLogin(router: VueRouter, target = location.href) {
  router.push({ name: accountLoginRoute.name, query: { target } })
}

export function redirectToAccountLogin(router: VueRouter, target = location.href) {
  router.replace({ name: accountLoginRoute.name, query: { target } })
}

export function navigateToAuthInprogress(router: VueRouter) {
  router.push({ name: authInprogressRoute.name })
}

export function redirectToAuthInprogress(router: VueRouter) {
  router.replace({ name: authInprogressRoute.name })
}
